import Edit16 from '@carbon/icons-react/es/edit/16';
import OverflowMenuVertical16 from '@carbon/icons-react/es/overflow-menu--vertical/16';
import { Dropdown, Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { Space } from 'data/spaces';
import { deleteSpaceInProjectTemplate } from 'data/templates/projects/actions';
import { useDeleteConfirmModal } from 'hooks/use-delete-confirm-modal';
import { useTranslation } from 'hooks/use-translation';

enum MoreActionsKeys {
  Edit = 'Edit',
  Delete = 'Delete',
}

type MoreActionsProps = AtLeast<Space, 'spaceId' | 'spaceName'> & {
  onEdit(): void;
};

export const MoreActions: FC<MoreActionsProps> = ({
  spaceId,
  spaceName,
  onEdit,
}) => {
  const title = useTranslation('space.delete.confirm.title');
  const content = useTranslation('space.delete.confirm.message');
  const moreActions = useTranslation('more_actions');
  const dispatch = useDispatch();

  const handleConfirmDelete = () => {
    dispatch(deleteSpaceInProjectTemplate({ space: { spaceId } }));
  };

  const DeleteConfirmation = useDeleteConfirmModal({
    title,
    content,
    onOk: () => handleConfirmDelete(),
  });

  const MoreActionsMenu = () => (
    <Menu>
      <Menu.Header>
        <FormattedMessage id="more_actions" />
      </Menu.Header>
      <Menu.Item
        onClick={onEdit}
        key={MoreActionsKeys.Edit}
        icon={<Edit16 />}
        data-cy={`space_${spaceName}.more_actions.edit`}
      >
        <FormattedMessage id="edit" />
      </Menu.Item>
      <Menu.Divider />
      <Menu.ItemDelete
        key={MoreActionsKeys.Delete}
        onClick={DeleteConfirmation}
        data-cy={`space_${spaceName}.more_actions.delete`}
      />
    </Menu>
  );

  return (
    <Tooltip title={moreActions} placement="topRight" mouseEnterDelay={1.5}>
      <Dropdown
        className="more-actions"
        overlay={MoreActionsMenu}
        trigger={['click']}
        placement="bottomLeft"
      >
        <Button
          type="text"
          icon={<OverflowMenuVertical16 />}
          size="small"
          data-cy={`space_${spaceName}.more_actions.button`}
        />
      </Dropdown>
    </Tooltip>
  );
};
